import React from 'react';
import Form from 'react-bootstrap/Form'
import InputGroup from "react-bootstrap/InputGroup"
import jwtClient from "../JwtClient";
import Storage from "../Storage";
import {nanoid} from 'nanoid'

export default class Track extends React.Component {
    state = {error: ''};

    render() {
        const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
        } = this.props;
        return (
            <Form.Group>
                <InputGroup>
                    <InputGroup.Prepend>
                        <InputGroup.Text>
                            <small>Reference/order number</small>
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control
                        name="track"
                        value={values.track}
                        disabled={Storage.isHumAid()}
                        onChange={event => {
                            handleChange(event);
                            this.setState({error: ''});
                            this.props.disableSubmit(false);
                        }}
                        onBlur={event => {
                            handleBlur(event);
                            if (!errors.track) {
                                jwtClient.get(`/api/v1/package/list?q=${values.track}`)
                                    .then(response => {
                                        if (response.data.results.length > 0) {
                                            this.setState({error: 'Already exists'})
                                            this.props.disableSubmit(true);
                                        }
                                    })
                            }
                        }}
                        isInvalid={this.state.error || (touched.track && !!errors.track)}
                    />
                    <Form.Control.Feedback type="invalid">
                        {this.state.error || errors.track}
                    </Form.Control.Feedback>
                </InputGroup>
            </Form.Group>
        )
    }

    componentDidMount() {
        if (Storage.isHumAid()) {
            // formik setFieldValue is not working correctly in component did mount
            // https://github.com/jaredpalmer/formik/issues/930
            const track = generateHumTrack();

            setTimeout(() => (this.props.setFieldValue('track', track)), 10)
        }
    }
}

// replace '_' with '0' because only letters, numbers and dashes are allowed
function generateHumTrack() {
    return 'HUM0' + nanoid(7).toUpperCase().replace(/_/g, '0');
}